import { PortfolioPageAttributes } from '@/types'
import { CreatePortfolioPageMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { Editor } from './editor'

interface Props {
  defaultValues?: Partial<PortfolioPageAttributes>
  onSuccess: () => void
}

export const Form = ({ defaultValues, onSuccess }: Props) => {
  const {
    attributes,
    setAttributes,
    save,
    saveSuccess,
    formBuilder,
    mutationLoading
  } = useForm<CreatePortfolioPageMutation, PortfolioPageAttributes, never, never>({
    defaultValues: {
      eventId: '',
      body: '',
      enabled: true,
      title: '',
      ...defaultValues,
    },
    mutation: CreateMutation,
    resultKey: 'createPortfolioPage',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      <div className="grid grid-cols-2 gap-6">
        { formBuilder.buildField({ name: 'Title', field: 'title', type: 'text' }) }
        { formBuilder.buildField({ name: 'Description', field: 'description', type: 'text' }) }
        { formBuilder.buildField({ name: 'Slug', field: 'slug', type: 'text' }) }
        { formBuilder.buildField({ name: 'Enabled', field: 'enabled', type: 'switch' }) }
      </div>
      { formBuilder.buildCustomField({
        name: 'Content',
        field: 'body',
        input: <Editor content={attributes.body} onChange={body => setAttributes(attrs => ({ ...attrs, body }))} />
      })}
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
